// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/organization.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.Organization
 */
export const Organization = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Organization",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reporting_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "fiscal_year_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "settings", kind: "message", T: Struct },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListOrganizationsRequest
 */
export const ListOrganizationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrganizationsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListOrganizationsResponse
 */
export const ListOrganizationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListOrganizationsResponse",
  () => [
    { no: 1, name: "organizations", kind: "message", T: Organization, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetOrganizationRequest
 */
export const GetOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOrganizationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateOrganizationRequest
 */
export const CreateOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateOrganizationRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reporting_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fiscal_year_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateOrganizationRequest
 */
export const UpdateOrganizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateOrganizationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "reporting_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "fiscal_year_start", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "settings", kind: "message", T: Struct },
  ],
);

